import { Alert } from "@mui/material";
import React, { createContext, useCallback, useState } from "react";
import { FixedSnackbarProvider } from "../components/Common/FixedSnackbarProvider";

export const ToastContext = createContext(null);

const DEFAULT_DURATION = 3000;

// Helper function to ensure duration is a number
const ensureNumericDuration = (duration) => {
  return typeof duration === "number" ? duration : DEFAULT_DURATION;
};

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
    duration: DEFAULT_DURATION,
  });

  const closeToast = useCallback((event, reason) => {
    if (reason === "clickaway") return;
    setToast((prev) => ({ ...prev, open: false }));
  }, []);

  const showToast = useCallback((message, severity = "success", duration = DEFAULT_DURATION) => {
    setToast({
      open: true,
      message,
      severity,
      duration: ensureNumericDuration(duration),
    });
  }, []);

  const toastService = {
    success: (message, duration) => showToast(message, "success", duration),
    error: (message, duration) => showToast(message, "error", duration),
    warning: (message, duration) => showToast(message, "warning", duration),
    info: (message, duration) => showToast(message, "info", duration),
  };

  return (
    <ToastContext.Provider value={toastService}>
      {children}
      <FixedSnackbarProvider open={toast.open} autoHideDuration={toast.duration} onClose={closeToast} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={closeToast} severity={toast.severity} sx={{ width: "100%" }}>
          {toast.message}
        </Alert>
      </FixedSnackbarProvider>
    </ToastContext.Provider>
  );
};
